import React, {Suspense} from 'react';
import {ErrorBoundary} from 'react-error-boundary';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import AdditionalText, {AdditionalTextLoading} from '@di-shared/features/diag/tire/AdditionalText';
import RecommendedTirePressure, {
  RecommendedTirePressureError,
  RecommendedTirePressureLoading,
} from '@di-shared/features/diag/tire/RecommendedTirePressure';
import TirePressureInstruction from '@di-shared/features/diag/tire/TirePressureInstruction';
import TirePressureViewer, {TirePressureViewerError, TirePressureViewerLoading} from '@di-shared/features/diag/tire/TirePressureViewer';
import ConsentBannerKr from '@di-shared/features/home/kr/ConsentBanner.kr';
import ConsentBannerLoadingKr from '@di-shared/features/home/kr/ConsentBannerLoading.kr';

interface TirePressureKRProps {
  vin: string;
}

function TirePressureKR({vin}: TirePressureKRProps) {
  const {t} = useInferableTranslation();
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header left={<HeaderBackButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T30002')}</h1>
      </Header>
      <main className="content page_car_management">
        <ErrorBoundary fallback={<></>}>
          <Suspense fallback={<ConsentBannerLoadingKr />}>
            <ConsentBannerKr vin={vin} />
          </Suspense>
        </ErrorBoundary>
        <section className="section">
          <ErrorBoundary fallback={<TirePressureViewerError />}>
            <Suspense fallback={<TirePressureViewerLoading />}>
              <TirePressureViewer vin={vin} />
            </Suspense>
          </ErrorBoundary>
          <ErrorBoundary fallback={<RecommendedTirePressureError />}>
            <Suspense fallback={<RecommendedTirePressureLoading />}>
              <RecommendedTirePressure vin={vin} />
            </Suspense>
          </ErrorBoundary>
          <TirePressureInstruction />
        </section>
        <div className="divider divider_thick"></div>
        <section className="section section_notice">
          <ErrorBoundary fallback={<></>}>
            <Suspense fallback={<AdditionalTextLoading />}>
              <AdditionalText vin={vin} />
            </Suspense>
          </ErrorBoundary>
        </section>
      </main>
    </div>
  );
}

export default TirePressureKR;
